import { defineMessages } from 'react-intl'

const scope = `procurify.expense.presenter.ApprovableTravelListPresenter`

export default defineMessages({
  sortByTravelNumberLabel: {
    id: `${scope}.sortByTravelNumberLabel`,
    defaultMessage: 'Travel number',
  },
  searchPlaceholder: {
    id: `${scope}.searchPlaceholder`,
    defaultMessage: 'Search travel requests...',
  },
  selectAllLabel: {
    id: `${scope}.selectAllLabel`,
    defaultMessage: 'Select all travel requests',
  },
  denyTravelButton: {
    id: `${scope}.denyTravelButton`,
    defaultMessage: 'Deny travel',
  },
  approveTravelButton: {
    id: `${scope}.approveTravelButton`,
    defaultMessage: 'Approve travel',
  },
  selectedTravelsCount: {
    id: `${scope}.selectedTravelsCount`,
    defaultMessage:
      '{count} {count, plural, one {travel request} other {travel requests}} selected',
  },
  errorToastTitle: {
    id: `${scope}.errorToastTitle`,
    defaultMessage: 'Unable to load travel requests',
  },
  errorToastMessage: {
    id: `${scope}.errorToastMessage`,
    defaultMessage: 'An error occurred loading travel requests',
  },
})
